var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-card-title',{staticClass:"h1 justify-center"},[_vm._v("Editar Controlador")]),_c('controlador-form',{ref:"form",on:{"save":_vm.save,"close":function($event){return _vm.$emit('close')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }